import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { commonSelector, rxCloseAlertModal } from "../../../app/features/common/common.slice";
import { useAppDispatch, useAppSelector } from "../../../hooks/redux.hook";
import FaIcon from "../FaIcon";
import { ERROR, SUCCESS, WARNING } from "../../../utils/enum/responseStates.enum";
import NextButton from "../../next/NextButton";

const ModalAlert = () => {
  const dispatch = useAppDispatch();
  const { modalAlert } = useAppSelector(commonSelector);
  const { isOpen, message, type, callbackOk } = modalAlert;
  const onCloseModal = () => {
    dispatch(rxCloseAlertModal());
    if (callbackOk) {
      callbackOk();
    }
  };

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={() => {}}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>
        <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                <Dialog.Title as="h3" className="text-lg font-medium leading-6 text-gray-900">
                  {type === SUCCESS ? <FaIcon prefix="fas" icon="circle-check" classes="text-green-500" /> : <></>}
                  {type === WARNING ? (
                    <FaIcon prefix="fas" icon="triangle-exclamation" classes="text-yellow-500" />
                  ) : (
                    <></>
                  )}
                  {type === ERROR ? <FaIcon prefix="fas" icon="circle-exclamation" classes="text-red-500" /> : <></>}
                  Notificación
                </Dialog.Title>

                <div className="mt-5 text-justify">
                  <p className="text-sm text-gray-500">{message}</p>
                </div>

                <div className="mt-5 flex justify-end">
                  <NextButton label="Aceptar" icon={"check"} onClick={onCloseModal} type="primary" />
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default ModalAlert;
